import src from "IMAGE";
export default { src, width: 43, height: 38, blurWidth: 0, blurHeight: 0};
